<template>
  <div
    class="tab-pane fade"
    id="nav-readings"
    role="tabpanel"
    aria-labelledby="nav-readings-tab"
  >
    <div class="container-fluid no-pad" v-if="activeService && customer">
      <div
        id="readings_accordion"
        v-if="activeServiceType === 'Gas' || (activeServiceType === 'Electricity' && hasHistoricNHHReadings)"
      >
        <div class="card mb-0">
          <div class="card-header col-sm-12" data-toggle="collapse">
            <div class="row">
              <div class="col-9">
                <p>Filter Readings</p>
              </div>
              <div class="col-3 col-sm-3">
                <button
                  type="button"
                  @click="filterShow = !filterShow"
                  class="more btn btn-hc-nb float-right"
                  :class="{ collapsed: !filterShow}"
                ></button>
              </div>
            </div>
            <div :class="{ collapse: !filterShow }" style="transition: all 0.4s">
              <hr class="mb-3" />
              <div class="row pb-2">
                <div class="col-12 col-md-5 my-3">
                  <div class="row">
                    <p class="col-auto font-weight-bold d-inline">Meter:</p>
                    <select
                      v-model="meterSerialFilter"
                      class="col form-control"
                      name="selection"
                      required
                    >
                      <option v-if="activeServiceType !== 'Electricity'">
                        All
                      </option>
                      <option
                        v-for="meter in nhhMeters"
                        :key="meter.Serial"
                        :value="meter.Serial"
                      >
                        {{ meter.Serial }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md">
                  <div class="row">
                    <p
                      class="col-7 col-md col-lg-auto font-weight-bold d-inline"
                    >
                      Customer:
                    </p>
                    <switches
                      class="col-auto text-center"
                      v-model="showOnlyCustomer"
                      type-bold="true"
                      theme="bootstrap"
                      color="success"
                      text-enabled="Single"
                      text-disabled="All"
                    ></switches>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md">
                  <div class="row">
                    <p
                      class="col-7 col-md col-lg-auto font-weight-bold d-inline"
                    >
                      Excluded Readings:
                    </p>
                    <switches
                      class="col-auto text-center"
                      v-model="showExcludedReadings"
                      type-bold="true"
                      theme="bootstrap"
                      color="success"
                      text-enabled="Show"
                      text-disabled="Hide"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- card-header collapsed col-sm-12 close -->
      </div>
      <!-- readings_accordion close -->
      <div class="row mt-3">
        <div class="col-12 my-auto">
          <h5 class="d-inline">Meter Readings ({{ meterSerialFilter }})</h5>
          <a class="btn btn-hc-nb" role="button" @click="showPanel" v-if="canAddReadingToSelectedMeter">
            <img
              src="@/assets/img/add_icon_hcg.png"
              class="pl-2 d-inline-block"
              alt="Add Icon"
            />
          </a>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-sm-12">
          <readings-table
            v-if="activeServiceType === 'Gas' || activeServiceType === 'Electricity'"
            :fuel="activeServiceType === 'Gas' ? 'gas' : 'elec'"
          />
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReadingsPanel from '@/components/panels/readings-panel-components/ReadingsPanel';

import ReadingsTable from './components/ReadingsTable';

export default {
	name: 'readings',
	components: {
		ReadingsPanel,
		ReadingsTable,
	},
	data() {
		return {
			startDate: '',
			endDate: '',

			P_filterShow: undefined,
		};
	},
	computed: {
		filterShow: {
			get() {
				if (this.P_filterShow !== undefined) return this.P_filterShow;
				else return this.meters.length > 1;
			},
			set(val) {
				this.P_filterShow = val;
			},
		},

		activeService() {
			return this.$store.state.meters.activeService;
		},
		activeServiceType() {
			return this.$store.getters.activeServiceType;
		},
		measurementMethod() {
			return this.$store.getters.measurementMethod;
		},

		currentMeter() {
			return this.meters.reduce(
				(latestMeter, currentMeter) =>
					latestMeter.Installed > currentMeter.Installed
						? latestMeter
						: currentMeter
			);
		},

		meters() {
			return this.$store.state.meters.activeService.Meters;
		},
		meterSerialFilter: {
			get() {
				return this.$store.getters.meterSerialFilter;
			},
			set(filter) {
				this.$store.commit('updateMeterSerialFilter', filter);
			},
		},
		showOnlyCustomer: {
			get() {
				return this.$store.state.meters.showOnlyCustomer;
			},
			set(bool) {
				this.$store.commit('updateShowOnlyCustomer', bool);
			},
		},
		showExcludedReadings: {
			get() {
				return this.$store.state.meters.showExcludedReadings;
			},
			set(bool) {
				this.$store.commit('updateShowExcludedReadings', bool);
			},
		},
		customer() {
			return this.$store.state.customers.customer;
		},

		nhhMeters() {
			return this.$store.getters.nhhMeters;
		},

		hasHistoricNHHReadings() {
			return this.$store.getters.hasHistoricNHHReadings;
		},

		canAddReadingToSelectedMeter() {
			return this.$store.getters.canAddReadingToSelectedMeter;
		},

		// contracts() {
		//   return this.$store.state.contracts.contracts;
		// },
		// readings() {
		//   return this.activeService.Readings;
		// },
	},
	methods: {
		showPanel() {
			this.$showPanel({
				component: ReadingsPanel,
				openOn: 'right',
				cssClass: 'add-meter-reading-panel',
				props: {},
			});
		},
		showAddReading() {
			$('.addMeterReading').modal('toggle');
		},
		billingInfo(invoice) {
			return this.$_.where(this.bills, {
				InvoiceNumber: invoice,
			});
		},
		clearFilter: function() {
			this.startDate = null;
			this.endDate = null;
		},
	},
};
</script>
